"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAmountRuleSet = exports.createActionRuleSet = void 0;
var anchor_1 = __importDefault(require("./anchor"));
var mirror_1 = __importDefault(require("./mirror"));
var pylon_1 = __importDefault(require("./pylon"));
var terra_core_1 = __importDefault(require("./terra-core"));
var cw20_1 = __importDefault(require("./cw20"));
var amount_1 = __importDefault(require("./amount"));
var createActionRuleSet = function (network) {
    return [cw20_1.default(), anchor_1.default(network), mirror_1.default(network), pylon_1.default(network), terra_core_1.default()].flat();
};
exports.createActionRuleSet = createActionRuleSet;
var createAmountRuleSet = function () { return amount_1.default(); };
exports.createAmountRuleSet = createAmountRuleSet;
//# sourceMappingURL=create.js.map